import React, { useRef } from 'react';
import { motion, useScroll, useTransform, MotionValue } from 'framer-motion';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';
import { useCmsContent } from '@/hooks/useCmsContent';

const imageUrl = "https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images/intro-vm.webp";

const defaultText = "Bij Vermado draait alles om exclusieve voertuigen en geavanceerde motoroptimalisatie. Wij combineren passie voor prestaties met vakmanschap op het hoogste niveau. Voor autoliefhebbers die het beste verwachten.";

function Word({ word, range, progress }: { word: string; range: [number, number]; progress: MotionValue<number> }) {
  const color = useTransform(progress, range, ["rgba(0,0,0,0.12)", "rgba(0,0,0,1)"]);
  return (
    <motion.span style={{ color }} className="inline-block mr-[0.3em]">
      {word}
    </motion.span>
  );
}

const WelcomeSection = () => {
  const { getContent } = useCmsContent('home');
  const navigate = useNavigate();
  const sectionRef = useRef<HTMLElement>(null);
  const text = getContent('welcome_statement', defaultText);
  const words = text.split(' ');

  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start end", "center center"],
  });

  return (
    <section ref={sectionRef} id="welcome" className="w-full py-16 md:py-36 lg:py-44 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-8 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24 items-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-7"
          >
            <p className="text-lg sm:text-xl md:text-2xl lg:text-[1.65rem] font-normal leading-[2.5] tracking-normal mb-14" style={{ fontFamily: "'Manrope', sans-serif" }}>
              {words.map((word, i) => {
                const start = i / words.length;
                const end = (i + 1) / words.length;
                return <Word key={i} word={word} range={[start, end]} progress={scrollYProgress} />;
              })}
            </p>

            <Button
              onClick={() => navigate('/werkplaats')}
              className="bg-black hover:bg-neutral-800 text-white text-xs font-semibold px-8 py-5 h-auto rounded-full uppercase tracking-[0.15em] transition-colors"
            >
              <span>{getContent('welcome_button_text', 'Meer over Vermado')}</span>
            </Button>
          </motion.div>

          {/* Image - 5 columns */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.15 }}
            className="lg:col-span-5 overflow-hidden rounded-2xl"
          >
            <img
              src={imageUrl}
              alt="Vermado Automotive"
              className="w-full h-full object-cover aspect-[3/4]"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WelcomeSection;
